import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import { toastFail } from "../../../config";
import { Button } from "../../../ds2/components";
import "./AppDocumentsUploadButton.css";

type AppDocumentsUploadButtonProps = {
  label: string;
  showFilename?: boolean;
  onFileSelect?: (file: File) => void;
  disabled?: boolean;
}

const MAX_FILE_UPLOAD_SIZE = 104857600; // 100MB (increased for video files)

const ACCEPTABLE_FILES =
  // Documents
  "application/pdf, " +
  "application/msword, " +
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document, " +
  "text/markdown, " +
  // Images
  "image/jpeg, image/jpg, image/png, image/gif, image/svg+xml, image/webp, image/bmp, image/x-icon, image/tiff, " +
  // Videos
  "video/mp4, video/avi, video/quicktime, video/x-ms-wmv, video/webm, video/x-matroska, video/x-flv, video/mp4, video/3gpp, video/ogg, ";

export const AppDocumentsUploadButton = ({ 
    label, 
    showFilename = true,
    onFileSelect, 
    disabled }: AppDocumentsUploadButtonProps) => {
    

    const [uploadFile, setUploadFile] = useState<string>("")
    const fileInputRef = useRef<HTMLInputElement>(null);

    // useEffect(()=> {
    //     setUploadFile("");
    // }, [])

    const handleOpenFilePicker = () => {
        // alert("Ref: " + fileInputRef?.current);

        if (fileInputRef?.current) {
          const inputButton = fileInputRef.current;
          setUploadFile("");
          inputButton.click();
        }
      };

    

    const handleFileChange = (event: any) => {
        for (let i = 0; i < event.target.files.length; i++) {
            if (event.target.files[i].size > MAX_FILE_UPLOAD_SIZE) {
                toast("File is too big! Please keep it under 100MB", toastFail);
                return;
            }
        }

        const file = event.target.files?.[0];
            if (file && onFileSelect) {
                setUploadFile(file.name);
                onFileSelect(file);
            }
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
        }
    };

    return (
        <div
            className="app-documents-upload-button"
        >
            <Button
                variant="secondary"
                onClick={handleOpenFilePicker}
                disabled={disabled}>
                {uploadFile ? "Change File" : label}
            </Button>

            {/* {showFilename && uploadFile && (
                <div className="app-documents-upload-button-filename">
                    {uploadFile}
                </div>
            )} */}
            
            {/* <button
                type="button"
                className="button-cancel"
                onClick={handleOpenFilePicker}
                disabled={disabled}
            >
                {uploadFile ? "Change File" : label}
            </button> */}
            <input
                type="file"
                ref={fileInputRef}
                // value={uploadFile}
                onChange={handleFileChange}
                accept={ACCEPTABLE_FILES}
                disabled={disabled}
                multiple={false}
                aria-label={label}
                style={{ display: "none" }}
            />
        </div>
    );
};

